// Generated from assets/icons/tab-bar-chat-active.svg (TA-11013).
// Ids are derived per instance via useSvgIdPrefix() so two copies on one
// screen cannot collide. Edit this file rather than re-adding the .svg.
import * as React from 'react';
import Svg, { Path, Defs, LinearGradient, Stop } from 'react-native-svg';

import { useSvgIdPrefix } from '@hooks/useSvgIdPrefix';

import type { SvgProps } from 'react-native-svg';

export const TabBarChatActive = (props: SvgProps) => {
  const uid = useSvgIdPrefix();
  return (
    <Svg width={24} height={24} fill='none' viewBox='0 0 24 24' {...props}>
      <Path
        fill={`url(#${uid}-a)`}
        d='M2.45 12c0-5.523 4.477-10 10-10s10 4.477 10 10v8.182A1.82 1.82 0 0 1 20.632 22H12.45c-5.523 0-10-4.477-10-10'
      />
      <Path
        stroke='#035B60'
        strokeLinecap='round'
        strokeLinejoin='round'
        d='m11.617 8-2.5 8.333M15.783 8l-2.5 8.333M17.45 10.5H8.283m8.334 3.333H7.45'
      />
      <Defs>
        <LinearGradient
          id={`${uid}-a`}
          x1={5.95}
          x2={27.45}
          y1={4.5}
          y2={27}
          gradientUnits='userSpaceOnUse'>
          <Stop stopColor='#97D8C6' />
          <Stop offset={1} stopColor='#32866F' />
        </LinearGradient>
      </Defs>
    </Svg>
  );
};
